import Vue from 'vue';

import { BootstrapVue } from 'bootstrap-vue';
import $ from 'jquery';
window.jQuery = window.$ = $;

// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
